import {Component, Fragment} from '~preact';
import PropTypes from "prop-types";
import {ArrayUtils, resolvePolymorphVar, StoreHelpers, suID} from "@green24/npm-javascript-utils";
import Modal from "./Modal";
import {M_Modal_OptionsDefaults} from "../../models/Models_Modal";
import {AppUtils} from "../../class/AppUtils";
import ThemeComponent from "../theme/ThemeComponent";

class GlobalModal extends Component {
	constructor() {
		super();

		this.state = {
			content: [],
			toDestroy: [],
		};

		if(AppUtils.hasWindow) {
			window.modal = this;
		}
	}

	render({portalTarget}, {content, toDestroy}) {
		if(!content || content.length == 0) return null;

		return content.map((modalData) => {
			const {content, options, id} = modalData;
			const {accent, lifespan, onClosed} = options || {};

			return <Fragment key={id}>
				<ThemeComponent
					componentType={"modal"}
					fallback={props => <Modal {...props}/>}

					componentProps={{
						...options.props,
						accent,
						lifespan,
						portalTarget,
						opened: !toDestroy.includes(id),
						onClosed: () => {
							this._removeModal(id);

							onClosed?.();
						},
					}}
				>
					{content}
				</ThemeComponent>
			</Fragment>;
		});
	}

	/**
	 * Open
	 * ---
	 * @param {*} content
	 * @param {M_Modal_OptionsDefaults} options
	 */
	open(content, options) {
		if(content) {
			this.setState(state => {
				const id = options?.id ?? suID();

				let newContent = state.content.filter(modal => modal.options.id != id);
				let mergedOptions = StoreHelpers.deepMerge(M_Modal_OptionsDefaults, options, true);

				newContent = ArrayUtils.push(newContent, true, {
					content,
					options: mergedOptions,
					id,
				});

				return {
					content: newContent,
					toDestroy: mergedOptions.replaceCurrent && state.content.length > 0 ? [...state.toDestroy, ArrayUtils.lastItem(state.content).id] : state.toDestroy,
				}
			});
		}
		else {
			throw Error("No dialog content provided");
		}
	}

	close(target) {
		if(this.state.content.length > 0) {
			if(target) {
				this.setState(state => {
					let toDestroy = resolvePolymorphVar(
						target,
						{
							string: s => state.content.filter(modal => modal.options.namespace === s),
							boolean: b => b ? state.content : [],
							array: arr => state.content.filter(modal => arr.includes(modal.options.namespace)),
							function: f => f(state.content),
							number: n => [state.content[n]],
						},
						() => [],
						true
					);

					return {
						toDestroy: [...state.toDestroy, ...ArrayUtils.mapValid(toDestroy, modal => modal.id)],
					};
				});
			}
			else {
				this.setState(state => ({
					toDestroy: [...state.toDestroy, ArrayUtils.lastItem(state.content).id],
				}));
			}
		}
	}

	closeSpecific(id) {
		this.setState(state => {
			const toDestroy = [...state.toDestroy];

			ArrayUtils.pushUnique(toDestroy, id);

			return {
				toDestroy,
			}
		});
	}

	_removeModal(id) {
		this.setState(state => ({
			content: ArrayUtils.removeID(state.content, id, true, true),
			toDestroy: ArrayUtils.removeItem(state.toDestroy, id, true, true),
		}));
	}

	static get propTypes() {
		return {
			portalTarget: PropTypes.string,
		}
	}

	static get stateTypes() {
		return {
			content: PropTypes.element,
		}
	}

	static get defaultProps() {
		return {
			portalTarget: "#modalRoot",
		}
	}
}

export default GlobalModal;
